import { Common } from './common';
import {
  CreateValues,
  FindAllOptions,
  ProvisionalPatient,
} from './models/patient/provisional';

interface SendResponse {
  success: boolean;
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions): Promise<ProvisionalPatient[]> {
    const url = this.common.constructPath('/provisional-patients');
    return this.common.getJSON(url);
  }

  async createBulk(payload: {
    previsitLinkId: string;
    patients: CreateValues[];
  }): Promise<ProvisionalPatient[]> {
    const url = this.common.constructPath(`/provisional-patients`);
    return this.common.postJSON(url, payload);
  }

  async sendText(
    id: string,
    payload: { checkRateLimiter?: boolean } = {},
  ): Promise<SendResponse> {
    const url = this.common.constructPath(`/provisional-patients/${id}/text`);
    return this.common.postJSON(url, payload);
  }

  async sendEmail(
    id: string,
    payload: { checkRateLimiter?: boolean } = {},
  ): Promise<SendResponse> {
    const url = this.common.constructPath(`/provisional-patients/${id}/email`);
    return this.common.postJSON(url, payload);
  }
}
